module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"OveripCreative - Creative Agency","short_name":"OveripCreative","start_url":"/","background_color":"#0A65A8","theme_color":"#0A65A8","display":"standalone","icon":"src/images/logo.png","icons":[{"src":"src/images/logo.png","sizes":"192x192","type":"image/jpeg"},{"src":"src/images/logo.png","sizes":"512x512","type":"image/jpeg"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"014dcfb516af43ade03786cf85623905"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
